import {pref} from "@/assets/plugins/mps-common/preferences/preferences";

export default {

    install(Vue) {
        Vue.prototype.$pref = pref;
    }

}